import { render } from "./FichasEpidemiologicas.vue?vue&type=template&id=60b45f17"
import script from "./FichasEpidemiologicas.vue?vue&type=script&lang=js"
export * from "./FichasEpidemiologicas.vue?vue&type=script&lang=js"

import "./FichasEpidemiologicas.vue?vue&type=style&index=0&id=60b45f17&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__